
import { Section } from "./data-types";

export const EventsUpcoming: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Upcoming events", // (this can be live depending on time of year)
						content: () => [
							<p>
								For Dec to April:
							</p>,
							<p>
								GeoNIght 2026
							</p>,
							<p>
								Conference of Irish Geographers 2026
							</p>,
							<p>
								Our next event is the Conference of Irish Geographers - <a href="https://www.conferenceofirishgeographers.ie/">click here for further information</a>.
							</p>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/5.jpg"
						},
					},
				}
			]
		}
	]
}
